import { format } from 'date-fns';

import { FormValues } from '../types/announcements';

export const dateIsFutureOrTodayOrSame = (newDate: string, oldDate: string) => {
	// NOTE: if the new start date is today or in the future we dont
	// need to check if it is after the old start date because it is valid
	if (isFutureOrToday(newDate)) return true;

	// But if it is in the past we need to make sure it is the same as the old date
	// newDate format is 'YYYY-MM-DD'
	// oldDate format is 'YYYY-MM-DDTHH:MM:SSSZ'

	return newDate === oldDate.split('T')[0];
};

export const endDateIsAfterStartDate = (endDate: string, formValues: FormValues) => {
	if (!formValues.start_date) return true;
	// endDate format is 'YYYY-MM-DD'
	// formValues.start_date format is 'YYYY-MM-DD'

	const start = new Date(formValues.start_date);
	const end = new Date(endDate);

	return end > start;
};

export const isFutureDate = (value: string) => {
	// value format is 'YYYY-MM-DD' so format today the same before comparing
	const today = format(new Date(), 'yyyy-MM-dd');

	return new Date(value) > new Date(today);
};

export const isFutureOrToday = (value: string) => {
	// value format is 'YYYY-MM-DD' so format today the same way before comparing
	const today = format(new Date(), 'yyyy-MM-dd');

	return new Date(value) >= new Date(today);
};
